export const SET_GAMES_DATA = '[GAMES] SET_GAMES_DATA';

export const setGamesData = (data) => ({
  type: SET_GAMES_DATA,
  payload: data,
});
